import { GenIcon } from 'react-icons'

const CmMultiPromo = GenIcon({
  tag: 'svg',
  attr: { viewBox: '0 0 12 10' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M7.41211 0.234375L10.1406 3.00586C11.2793 4.14453 11.2793 5.9707 10.1406 7.10938L7.73438 9.53711C7.54102 9.75195 7.21875 9.75195 7.00391 9.53711C6.81055 9.34375 6.81055 9.02148 7.00391 8.82812L9.41016 6.37891C10.1406 5.64844 10.1406 4.4668 9.41016 3.73633L6.66016 0.943359C6.4668 0.75 6.4668 0.427734 6.68164 0.212891C6.875 0.0195312 7.19727 0.0195312 7.41211 0.234375ZM5.19922 0.470703L8.80859 4.08008C9.3457 4.61719 9.3457 5.49805 8.80859 6.03516L5.95117 8.89258C5.41406 9.42969 4.5332 9.42969 3.99609 8.89258L0.386719 5.2832C0.128906 5.02539 0 4.68164 0 4.31641V1.09375C0 0.535156 0.451172 0.0625 1.03125 0.0625H4.23242C4.59766 0.0625 4.94141 0.212891 5.19922 0.470703ZM1.03125 1.09375V4.31641C1.03125 4.40234 1.05273 4.48828 1.11719 4.55273L4.72656 8.16211C4.85547 8.29102 5.0918 8.29102 5.2207 8.16211L8.07812 5.30469C8.22852 5.17578 8.22852 4.93945 8.07812 4.81055L4.46875 1.20117C4.4043 1.13672 4.31836 1.09375 4.23242 1.09375H1.03125ZM3.09375 2.46875C3.09375 2.85547 2.77148 3.15625 2.40625 3.15625C2.01953 3.15625 1.71875 2.85547 1.71875 2.46875C1.71875 2.10352 2.01953 1.78125 2.40625 1.78125C2.77148 1.78125 3.09375 2.10352 3.09375 2.46875Z'
      },
      child: []
    }
  ]
})

export default CmMultiPromo
